import { CountryLanguage } from './../interface/country-language';
import { EventEmitter, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CountryPhoneNumberFormats } from '../../common/constants/country-phonenumber-format.constants';
import { DiscountTypeConstants } from '../../common/constants/dispute-type.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { MemberPreferenceType } from '../../common/enums/member-preference.enum';
import { Permission } from '../../common/enums/permission.enum';
import { PreferenceValues } from '../../common/enums/preference-value.enum';
import { Constants } from '../../customerservice/common/constants';
import { MemberLevel, OrderType, PromotionActionType } from '../../customerservice/common/enumerations';
import { DiscountType } from '../../customerservice/enums/discount-type.enum';
import { MemberTypeEnum } from '../../customerservice/enums/member-type.enum';
import { NotificationType } from '../../customerservice/enums/notification-types.enum';
import { PaymentMethodTypes, PurchaseFlows } from '../../customerservice/enums/order-source-type';
import { PriceTier, PriceTierMemberType } from '../../customerservice/enums/price-tier.enum';
import { ActivityLog } from '../../customerservice/interface/activityLog';
import { ActivityLogKey } from '../../customerservice/interface/activityLogKey';
import { Address } from '../../customerservice/interface/address';
import { DiscountPercentageResponse } from '../../customerservice/interface/discount-percentage.response.interface';
import { SponsorInformation, SponsorSearchRequest, SponsorSearchResponse } from '../../customerservice/interface/enrollment';
import { MemberSearchByFboIdResponse } from '../../customerservice/interface/member-search-by-fboid-response';
import { SearchRequest } from '../../customerservice/interface/search-request';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { RoutePermission } from '../../shared/interface/route-permission';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { MemberActivityLogPortal } from '../common/enumerations';
import { CommonConstant } from '../constants/common.constants';
import { VerticalTree } from '../interface/vertical-tree.interface';
import { environment } from './../../../environments/environment';
import { ImageType } from '../../customerservice/enums/image-type.enum';
import { StockQuantity } from '../../customerservice/interface/stock-quantity';
import { PaymentMethodSourceConfiguration } from '../interface/payment-method-source-configuration.interface';
import { AppConfigService } from '../../customerservice/services/app-config.service';
import { Country } from '../interface/country.interface';
import { MemberAllowedCountries } from '../interface/member-allowed-countries.interface';
import { TranslateParam } from '../interface/translate-param.interface';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators';
import { SnapPayload } from '../../customerservice/interface/snapshot-details';
import { UserTitleType } from '../../customerservice/common/constants'; 
import { StoreConfig } from '../interface/StoreConfig.interface';
import { MemberPreferencesType } from '../../customerservice/enums/member-preferences.enum';
import { PaymentMethodTypeConstants } from '../../customerservice/constants/payment-method-types.constants';
import { ShippingMethod } from '../../customerservice/interface/ship-method';
import { PromotionRewardTypeEnum } from '../../customerservice/enums/promotion-reward-type.enum';
@Injectable()
export class CommonService {

  private downlineUrl: string = environment.uiTemplateBaseUrl +
    '/test/downline.json';

  private _languages = environment.uiTemplateBaseUrl +
    '/test/language.json';
  private _appSideMenuBar = environment.uiTemplateBaseUrl +
    '/test/app-side-menu-bar.json';
  private routePermissionURL: string = environment.uiTemplateBaseUrl + '/test/route-permission.json';

  private _personaliInfoFormValidation = environment.cdnURL + '/portals/customercare/template1/schema-forms/';

  //Collection of EventEmitter object;
  private _eventEmitters: { [id: string]: EventEmitter<any> } = {};
  private userInfo: UserInfo;
  private itemSubTotal: number;
  private totalCC: number;
  private countryTaxInclusive: boolean;

  constructor(
    private _http: Http,
    private _cacheService: CacheService,
    private _notificationService: NotificationsService,
    private appConfigService: AppConfigService

  ) {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
  }

  /**
   * Create a singleton EventEmitter Object
   *  for a given Id
   * @param Id {String}
   * @returns eventEmitter {EventEmitter}
   * */
  getEmitter(id: string): EventEmitter<any> {
    if (this._eventEmitters[id] === undefined) {
      this._eventEmitters[id] = new EventEmitter();
    }
    return this._eventEmitters[id];
  }


  /**
   * To get all configurations
   * @returns Observable
   */
  getConfiguration(countryName: string): Observable<any[]> {
    const baseUrl: string = process.env.ENV === 'production' ? environment.baseHref : 'http://shop.dev.flptitan.com/';
    return this._http.
      get(baseUrl + 'api/Configuration?countryName=' + countryName)
      .map((res: any) => res.json());
  }

  /**
   * @param  {number} userId
   * @returns Observable
   */
  getDownline(userId: number): Observable<any[]> {
    return this._http.get(this.downlineUrl).map(res => res.json());
  }


  getLanguages(): Observable<any[]> {
    return this._http.get(this._languages).map(res => res.json());
  }

  /**
   * to get static side menu bar
   * @returns Observable
   */
  getSideMenuBar(): Observable<any[]> {
    return this._http.get(this._appSideMenuBar).map(res => res.json());
  }

  checkPermissionList(value: String[], isStore?: Boolean, storeId?: Number) {
    if (value instanceof Array) {

      if (this.userInfo && this.userInfo.hasSystemRole) {
        return true;
      } else if (isStore && storeId && storeId > 0) {
        const manageStorePermissions: Number[] = [Permission.MANAGE_STORE_CREATE, Permission.MANAGE_STORE_VIEW, Permission.MANAGE_STORE_EDIT, Permission.MANAGE_STORE_DELETE];
        const userStorePermissions: any[] = this.userInfo.privileges.stores;
        const userAccountPermissions: any[] = this.userInfo.privileges.account;
        if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
          return true;
        } else if (userStorePermissions && userStorePermissions.length > 0) {
          const store = userStorePermissions.filter(item => item.id === storeId)[0];
          if (store) {
            return store.permissions.some((item: any) => value.indexOf(item) >= 0);
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        if (this.userInfo && this.userInfo.privileges) {
          const userAccountPermissions: any[] = this.userInfo.privileges.account;
          if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else {
      return false;
    }
  }

  checkPermissionByAccessLevel(value: any, resourceTypeId: Number, resourceId?: Number) {
    const userInfo: UserInfo = this._cacheService.get(CacheKey.UserInfo);
    if ((value instanceof Array) && userInfo) {
      if (userInfo && userInfo.hasSystemRole) {
        return true;
      } else {
        return this.validateAccessLevelpermissions(userInfo, value, resourceTypeId, resourceId);
      }
    } else {
      return false;
    }
  }

  validateAccessLevelpermissions(userInfo: UserInfo, value: any, resourceTypeId: Number, resourceId?: Number): boolean {
    let isAllowed = false;
    switch (resourceTypeId) {
      case AccessLevel.Account: {
        const userAccountPermissions: any[] = userInfo.privileges.account;
        if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
          isAllowed = true;
        }
        break;
      }
      case AccessLevel.Customer_Service: {
        const userCSPermissions: any[] = userInfo.privileges.customerService;
        if (userCSPermissions && userCSPermissions.length > 0 && userCSPermissions.some(item => value.indexOf(item) >= 0)) {
          isAllowed = true;
        }
        break;
      }
      case AccessLevel.Department: {
        const userdeparmentPermissions: any[] = userInfo.privileges.departments;
        if (resourceId > 0 && userdeparmentPermissions && userdeparmentPermissions.length > 0) {
          const department = userdeparmentPermissions.filter(item => item.id === resourceId)[0];
          if (department) {
            isAllowed = department.permissions.some((item: any) => value.indexOf(item) >= 0);
          }
        }
        break;
      }
      case AccessLevel.Store: {
        const userStorePermissions: any[] = userInfo.privileges.stores;
        const userAccountPermissions: any[] = userInfo.privileges.account;
        if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
          isAllowed = true;
        } else if (resourceId > 0 && userStorePermissions && userStorePermissions.length > 0) {
          const store = userStorePermissions.filter(item => item.id === resourceId)[0];
          if (store) {
            isAllowed = store.permissions.some((item: any) => value.indexOf(item) >= 0);
          }
        }
        break;
      }
      case AccessLevel.CMS: {
        const userCMSPermissions: any[] = userInfo.privileges.cms;
        if (userCMSPermissions && userCMSPermissions.length > 0 && userCMSPermissions.some(item => value.indexOf(item) >= 0)) {
          isAllowed = true;
        }
        break;
      }
      default: {
        isAllowed = false;
        break;
      }
    }
    return isAllowed;
  }


  /**
    * Personal percentage based on UserTitleType
    * @param  {string} titleType
    * @returns break
    */
  getPersonalDiscount(memberTitleId: number): number {
    let discountPercenatge = 0;
    switch (memberTitleId) {
      case MemberLevel.ASSISTANTSUPERVISOR:
        discountPercenatge = 5;
        break;
      case MemberLevel.SUPERVISOR:
        discountPercenatge = 8;
        break;
      case MemberLevel.ASSISTANTMANAGER:
        discountPercenatge = 13;
        break;
      case MemberLevel.MANAGER:
      case MemberLevel.DIAMONDMANAGER:
      case MemberLevel.UNRECOGNIZEDMANAGER:
      case MemberLevel.RECOGNIZEDMANAGER:
      case MemberLevel.SENIORMANAGER:
      case MemberLevel.SOARINGMANAGER:
      case MemberLevel.SAPPHIREMANAGER:
      case MemberLevel.DIAMONDSAPPHIREMANAGER:
      case MemberLevel.DOUBLEDIAMONDMANAGER:
      case MemberLevel.TRIPLEDIAMONDMANAGER:
      case MemberLevel.DIAMONDCENTURIONMANAGER:
        discountPercenatge = 18;
        break;
      default:
        break;
    }
    return discountPercenatge;
  }


  /**
* @param {string} title
* @param {string} content
* @param {string} messageType
*/
  createNotification(title: string, content: string, messageType: string, timeOut?: Number, messageId?: string) {
    const notificationOptions = {
      id: messageId,
      timeOut: (timeOut >= 0 && timeOut !== null) ? timeOut : 0,
      showProgressBar: false,
      pauseOnHover: false,
      clickToClose: false,
      clickIconToClose: true,
      icons: this.getIcons()
    };
    const htmlTemplate = this.getNotificationTemplate(title, content);
    const type: any = this.getNotificationType(messageType);
    return this._notificationService.html(htmlTemplate, type, notificationOptions);
  }

  /**
   * @description to get Products tax inclusive total
   * @author Akhil
   * @date 2022-02-09
   * @param {any[]} products
   * @param {number} subTotal
   * @param {*} store
   * @returns
   * @memberof CommonService
   */
  getProductsTotalTax(products: any[], subTotal: number, store: any) {
    if (products && products.length && subTotal && store) {
      let totaltax = 0;
      for (let item of products) {
        if (item.taxAmount) {
          totaltax = totaltax + Number((item.taxAmount).toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
      }
      if (totaltax) {
        return Number((totaltax + subTotal).toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2))));
      }
      return subTotal;
    }
    return 0;
  }

  /**
   * @description
   * @date 2020-04-15
   * @memberof CommonService
   */
  removeNotification(messageId?: string): void {
    this._notificationService.remove(messageId);
  }

  setNotification(title: string, content: string, messageType: string, timeOut: Number, clickOnClose: Boolean, maxLength: Number) {
    const notificationOptions = {
      timeOut: (timeOut >= 0 && timeOut !== null) ? timeOut : 0,
      showProgressBar: false,
      pauseOnHover: false,
      clickToClose: !!clickOnClose,
      clickIconToClose: true,
      icons: this.getIcons(),
      maxLength: maxLength || 0
    };
    const htmlTemplate = this.getNotificationTemplate(title, content);
    const type: any = this.getNotificationType(messageType);
    this._notificationService.html(htmlTemplate, type, notificationOptions);
  }


  getIcons(): { [iconType: string]: string } {
    return {
      'success': '<i class="fa fa-times-circle" ></i>',
      'warn': '<i class="fa fa-times-circle" ></i>',
      'error': '<i class="fa fa-times-circle" ></i>',
      'alert': '<i class="fa fa-times-circle" ></i>',
      'info': '<i class="fa fa-times-circle" ></i>'
    };
  }

  getNotificationTemplate(title: string = '', content: string = ''): string {
    const html = `<div>
                    <div class="sn-title">` + title + `</div>
                    <div>` + content + `</div>
                  </div>`;
    return html;
  }

  getNotificationType(type: string): NotificationType {
    switch (type) {
      case 'success':
        return NotificationType.SUCCESS;
      case 'error':
        return NotificationType.ERROR;
      case 'warning':
        return NotificationType.WARN;
      case 'alert':
        return NotificationType.ALERT;
      case 'info':
        return NotificationType.INFO;
      default:
        return NotificationType.SUCCESS;
    }
  }

  checkPermission(permission: String) {

    if (this._cacheService.get(CacheKey.UserPermissions) != null && this._cacheService.get(CacheKey.UserPermissions) != undefined) {
      const permissionsArray = JSON.parse(this._cacheService.get(CacheKey.UserPermissions));
      if (permissionsArray.indexOf(permission) >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }


  getUserInformation(userName: String): Observable<UserInfo> {
    const url = environment.accountThroughGateway + 'users/' + userName + '/user-types/Titan-Internal/info'
    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => <UserInfo>res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || 'server error')
      );
  }

  /**
   * CustomerService - Gets search results
   * @param searchRequest
   * @param pageNumber
   * @param pageSize
   * @param sort
   * @param sortColumn
   */
   getFBOSearchResults(searchRequest: SearchRequest): Observable <MemberSearchByFboIdResponse> {
    let url=''; 
    if (searchRequest.searchBy === Constants.MEMBER) {  
        url = ApiUrlConstants.manageAccountApiGwUrl + 'member-search'
       
    }
    return this._http
      .post(url, JSON.stringify(searchRequest))
      .map((response: Response) => response.json())
      .catch(this.handleErrorObservable);
  
}

  /**
   * CustomerService - Gets account status
   * @param distributorID
   */
  getMemberStatus(distributorID: number): Observable<any> {
    return this._http
      .get(ApiUrlConstants.customerServiceApiUrl + 'account-status?distributorID='+ distributorID )
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
     * to get wholesale qualified details for a PC based on memberID and countryCode
     * @param  {any} memberId
     * @param  {any} countryCode
     * @returns Observable
     */
  getWholsesaleQualifiedDetails(memberId: string, countryCode: string): Observable<any> {
    return this._http
      .get(ApiUrlConstants.enrollmentApigwUrl + 'wholesaleQualifiedEligibilityCheck?distributorId='
        + memberId + '&operatingCountry=' + countryCode)

      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description
   * @date 2020-04-20
   * @param {string} memberId
   * @param {number} countryId
   * @returns {Observable<any>}
   * @memberof CommonService
   */
  getMemberRankLevelHistory(memberId: string, countryId: number): Observable<any> {
    return this._http
      .get(ApiUrlConstants.accountApiUrl + 'member/' + memberId + '/country/' + countryId + '/member-rank-level-history')

      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * to get wholesale qualified details for a PC based on memberID and countryCode
   * @param  {any} memberId
   * @param  {any} countryCode
   * @returns Observable
   */
  getDiscountPercentages(wholesaleQualified: boolean, optin: boolean, memberTitleID: number, storeId: number):
    Observable<DiscountPercentageResponse> {
    const url = ApiUrlConstants.configurationApiUrl
      + 'discount-percentages?wholeSaleQualified=' + wholesaleQualified + '&optin=' + optin
      + '&memberTitleId=' + memberTitleID + '&storeId=' + storeId;
    return this._http
      .get(url)

      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * getCountries Method used to get country list
   * @param  {number} distributorId
   * @param  {string} homeCountry ,homeCountry: string + homeCountry
   * @returns Observable
   */
  getCountries(distributorId: string, homeCountry: string): Observable<any> {
    const url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/countries?homeCountry=' + homeCountry;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSearchMemberDetails(distributors: String[], countryCode: string) {
    let url: string = ApiUrlConstants.reportApiUrl + '/search-detail?';
    distributors.forEach(ele => url = url + 'distributors=' + ele + '&');
    url = url + '&countryCode=' + countryCode;

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSearchList(distributorId: string, firstName: string, lastName: string, countryCode: string, rootId) {
    let url: string = ApiUrlConstants.reportApiUrl + '/search?countryCode=' + countryCode + '&rootId=' + rootId;

    if (distributorId != '') {
      url = url + '&distributorId=' + distributorId;
    } else if (firstName != '' && lastName != '') {
      url = url + '&firstName=' + firstName + '&lastName=' + lastName;
    }

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
      * getVerticalView Method used to get downline members of logged in fbo
      * @param  {number} distributorId
      * @param  {string} country
      * @returns Observable
      */
  getVerticalTree(distributorId: string, countryCode: string, memberLevel: number, fromDate: string, toDate: string, showNonZero: boolean): Observable<VerticalTree> {

    let initialurl;
    let appendurl = '';
    let url = '';
    initialurl = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/verticaltreeview?countryCode=' + countryCode
      + '&memberLevel=' + memberLevel + '&fromDate=' + fromDate + '&toDate=' + toDate + '&showNonZero=' + showNonZero;
    url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/verticaltreeview?';

    initialurl.split('?')[1].split('&').forEach(function (ele) {
      const value = ele.split('=')[1];
      if (value !== 'null' && value !== 'undefined' && value !== '') { appendurl += '&' + ele; }
    });
    url += appendurl.replace('&', '');

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
    * getVerticalView Method used to get downline members of logged in fbo
    * @param  {number} distributorId
    * @param  {string} country
    * @returns Observable
    */
  getVerticalTreeCCValues(distributorId: string, countryCode: string): Observable<any> {
    const url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/treeview-cc?countryCode=' + countryCode;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
      * getCCSnapshotDetails Method used to get ccs of logged in fbo
      * @param  {number} distributorId
      * @param  {string} country
      * @returns Observable
      */

   getTwoCCSnapshotDetails(distributorId: string, countryCode: string): Observable<any> {

    let initialurl;
    let appendurl = '';
    let url = '';

    initialurl = 'countryCode=' + countryCode;
    url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/cc-two-snapshot?';

    initialurl.split('&').forEach(function (ele) { let value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') { appendurl += '&' + ele; } });
    url += appendurl.replace('&', '');

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getCCSnapshotDetails(distributorId: string, countryCode: string): Observable<any> {

    let initialurl;
    let appendurl = '';
    let url = '';

    initialurl = 'countryCode=' + countryCode;
    url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/cc-snapshot?';

    initialurl.split('&').forEach(function (ele) { let value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') { appendurl += '&' + ele; } });
    url += appendurl.replace('&', '');

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getCCSnapDetails(reqObj:SnapPayload){
    let url;
    if (environment && environment.enableNewAggregation) {
      url = ApiUrlConstants.reportApiUrl+'/fboId/'+reqObj.distributorID+'/country/'+reqObj.country+'/year/'+reqObj.currentYear+'/month/'+reqObj.month+'/rewire-earnings-CC-summary?isVolume=false';
    }
    else{
      url = ApiUrlConstants.reportApiUrl+'/fboId/'+reqObj.distributorID+'/country/'+reqObj.country+'/year/'+reqObj.currentYear+'/month/'+reqObj.month+'/earnings-CC-summary?isVolume=false';
    }
    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .pipe(map((res:any) => res.json()),
        catchError(this.handleErrorObservable));
  }

  /**
    * getYearlyCaseCreditsDetails Method used to get ccs of logged in fbo
    * @param  {number} distributorId
    * @param  {string} country
    * @returns Observable
    */
  getYearlyCaseCreditsDetails(distributorId: string, countryCode: string, processingYear: number): Observable<any> {

    let initialurl;
    let appendurl = '';
    let url = '';

    initialurl = 'countryCode=' + countryCode + '&processingYear=' + processingYear;
    url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/casecredits?';

    initialurl.split('&').forEach(function (ele) { let value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') { appendurl += '&' + ele; } });
    url += appendurl.replace('&', '');


    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * getAveragePurchase Method used to get Average Purchase Data
   * @param  {number} distributorId
   * @param  {string} country
   * @returns Observable
   */
  getBonusRecapData(distributorId: string, country: string, month: number, year: number): Observable<any> {
    const url: string = ApiUrlConstants.reportApiUrl + '/member/bonusrecap/distributors/' + distributorId + '/countries/' + country + '?month=' + month + '&year=' + year;
    const headers = new Headers();
    headers.append('Accept', 'application/pdf');
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers
    });
    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)), options)
      .map((res: Response) => res)
      .catch(this.handleErrorObservable);
  }

  getMemberLevelDetails(distributorId: string) {
    const url: string = ApiUrlConstants.reportApiUrl + '/distributors/' +
      distributorId + '/member-information';

    return this._http
      .get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getRecognitionLevelsByParam(param: string) {
    return this._http
      .get(ApiUrlConstants.reportApiUrl + '/recognitionlevels/' + param)
      .map(response => response.json())
      .catch(this.handleErrorObservable);
  }

  async getRoutePermissions(): Promise<RoutePermission[]> {
    const response = await this._http.get(this.routePermissionURL).toPromise();
    return response.json();
  }

  arraySort(value: Array<any>, property: any, isDesc?: Boolean): Array<any> {

    const isDescOrder = isDesc ? isDesc : false; //change the direction

    const direction = (isDesc ? isDesc : false) ? 1 : -1;

    value.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return value;
  }


  /**
   * @description get purchase flow type
   * @returns {*}
   * @memberof CommonService
   */
  getPurchaseFlowType(memberTypeId: number, wholesaleQualified: boolean, fpc5percentEnabled?: boolean, isFPCEnrollment?: boolean, memberTitleId?: number): any {
    if ((memberTypeId === MemberTypeEnum.DISTRIBUTOR && memberTitleId !== MemberLevel.PREFERREDCUSTOMER)
      || ((memberTypeId === MemberTypeEnum.FPC || memberTitleId === MemberLevel.PREFERREDCUSTOMER) && wholesaleQualified)) {
      return PurchaseFlows.PERSONAL;
    } else if ((memberTypeId === MemberTypeEnum.FPC || memberTitleId === MemberLevel.PREFERREDCUSTOMER) && !wholesaleQualified) {
      return fpc5percentEnabled ? PurchaseFlows.FPC5PERCENT : PurchaseFlows.PERSONAL;
    } else if (isFPCEnrollment) {
      return PurchaseFlows.ENROLLMENT;
    } else {
      return PurchaseFlows.RETAIL;
    }
  }


  /**
   * save saveMemberActivity
   * @param  {any} Member Activity Log
   * @returns Observable
   */
  saveMemberActivity(memberId: Number, activityLogKeys: ActivityLogKey[]): Observable<any> {

    const activityLog: ActivityLog = {
      activities: activityLogKeys,
      portalId: MemberActivityLogPortal.CustomerService
    };

    return this._http
      .post(ApiUrlConstants.auditApiUrl + 'members/' + memberId + '/activitylog', activityLog)
      .map((res: Response) => res.text())
      .catch(this.handleErrorObservable);
  }



  /**
   *
   *
   * @memberof CommonService
   */
  getMemberActivityLogs = (requestPayload) => {
    let url = ApiUrlConstants.auditApiUrl + 'members/' + requestPayload.memberId + '/activitylogs?';
    if (requestPayload.sortBy) {
      url = url + '&sortBy=' + requestPayload.sortBy;
    }
    if (requestPayload.sortOrder) {
      url = url + '&sortOrder=' + requestPayload.sortOrder;
    }
    if (requestPayload.pageNumber) {
      url = url + '&pageNo=' + requestPayload.pageNumber;
    }
    if (requestPayload.pageSize) {
      url = url + '&pageSize=' + requestPayload.pageSize;
    }
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
 * @description to get error codes based on country,state and product item number
 * @param {*} productRestrictionModel
 * @returns
 * @memberof CommonService
 */
  getProductRestrictions(productRestrictionModel) {
    return this._http
      .post(ApiUrlConstants.shippingApiUrl + 'shipping-products-restriction', JSON.stringify(productRestrictionModel))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  /**
* @description get phone number format based on country code
* @date 2018-11-22
* @param {string} countryCode
* @returns {string}
* @memberof CommonService
*/
  getPhoneNumberFormatByCountryCode(countryCode: string): string {
    if(countryCode){
    const phoneNumberFormat = CountryPhoneNumberFormats.formats.find(item => item.countryCode.toUpperCase() === countryCode.toUpperCase());
    if (phoneNumberFormat) {
      return phoneNumberFormat.phoneNumberMaskFormat;
    } else {
      return CommonConstant.DefaultPhoneNumberFormat;
    }
  }else {
    return CommonConstant.DefaultPhoneNumberFormat;
  }
}

  /**
 * @description this method will return the price level based on member
 * @returns {string}
 * @memberof CommonService
 */
  getDiscountPriceLevel(priceTierId: number, discountPerc: number, memberTypeId: number, enableWHLSAL00ForAsstSupervisor: boolean, isServiceOrder?: boolean): string {
    let priceLevel: string;
    if (isServiceOrder) {
      return Constants.SERVICE_ORDER;
    }
    switch (priceTierId) {
      case PriceTier.RETAIL:
        priceLevel = PriceTierMemberType.RETAIL;
        break;
      case PriceTier.NEWDST:
        priceLevel = PriceTierMemberType.FPC + ' ' + discountPerc + '%';
        break;
      case PriceTier.WHLSAL:
        priceLevel = PriceTierMemberType.FPC + ' ' + discountPerc + '%';
        break;
      case PriceTier.WHLD05:
        priceLevel = PriceTierMemberType.FBO + ' ' + discountPerc + '%';
        break;
      case PriceTier.WHLD08:
      case PriceTier.WHLD13:
      case PriceTier.WHLD18:
        priceLevel = PriceTierMemberType.FBO + ' ' + discountPerc + '%';
        break;
      case PriceTier.RTLD5:
      case PriceTier.RTLD10:
      case PriceTier.RTLD15:
        priceLevel = PriceTierMemberType.RETAIL + ' ' + DiscountTypeConstants.discountTypes[priceTierId] + '%';
        break;
      case PriceTier.WHLD00:
        priceLevel = PriceTierMemberType.FBO ;
        break;
      case PriceTier.NEWFBO:
        priceLevel = PriceTierMemberType.NEWFBO;
        break;
      default:
        priceLevel = '';
        break;
    }
    return priceLevel;
  }



  /**
   * @description discount percentage based on UserTitleType
   * @param {number} memberTitleId
   * @param {boolean} wholesaleQualified
   * @returns {number}
   * @memberof CommonService
   */
  getDiscountPerc(memberDiscountPercentage: DiscountPercentageResponse): number {
    let discountPercenatge = 0;
    if (memberDiscountPercentage && memberDiscountPercentage.discountPercentage) {
      discountPercenatge = memberDiscountPercentage.discountPercentage;
    }
    return discountPercenatge;
  }

  /**
   * @description
   * @date 2019-09-17
   * @returns {number}
   * @memberof CommonService
   */
  getWholesaleQualifiedDisc(memberTitleId: number): number {
    let discountPercenatge = 0;
    switch (memberTitleId) {
      case MemberLevel.PREFERREDCUSTOMER:
        discountPercenatge = 0;
        break;
      case MemberLevel.ASSISTANTSUPERVISOR:
      case MemberLevel.SUPERVISOR:
      case MemberLevel.ASSISTANTMANAGER:
      case MemberLevel.MANAGER:
      case MemberLevel.DIAMONDMANAGER:
      case MemberLevel.UNRECOGNIZEDMANAGER:
      case MemberLevel.RECOGNIZEDMANAGER:
      case MemberLevel.SENIORMANAGER:
      case MemberLevel.SOARINGMANAGER:
      case MemberLevel.SAPPHIREMANAGER:
      case MemberLevel.DIAMONDSAPPHIREMANAGER:
      case MemberLevel.DOUBLEDIAMONDMANAGER:
      case MemberLevel.TRIPLEDIAMONDMANAGER:
      case MemberLevel.DIAMONDCENTURIONMANAGER:
        discountPercenatge = 30;
        break;
      default:
        break;
    }
    return discountPercenatge;
  }

  /**
 * @description Getting personal info form validations json
 *
 * @param {string} schemaUrl
 * @returns {Observable<any>}
 * @memberof CommonService
 */
  getFormValidationsJSON(): Observable<any> {
    return this._http
      .get(this._personaliInfoFormValidation + 'validations.json')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return Observable.throw(error.message || error);
      });
  }

  /**
   * This method is used for getting company policy agreement documents
   * getDocuments
   * @memberof CommonService
   */
  getDocuments(portalId: number, customerTypeId: number, displaySectionId: number, countryCode: string, languageCode: string) {
    return (this._http
      .get(ApiUrlConstants.accountApiUrl + 'documents?countryCode=' + countryCode + '&portal=' + portalId
        + '&customerTypeId=' + customerTypeId + '&preferredLangCode=' + languageCode + '&displaySectionId=' + displaySectionId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable));
  }

  /**
   * Sponsor Search
   * @param  {any} sponsorSearchRequest
   * @param  {number} limit?
   * @returns Observable
   */
  searchSponsors(sponsorSearchRequest: SponsorSearchRequest, limit?: number)
    : Observable<SponsorSearchResponse> {
      const orderType = OrderType.NEW_GUEST_RETAIL;
      const flowtype = OrderType[orderType];
    const _searchSponsorUrl = ApiUrlConstants.enrollmentApigwUrl +
    `sponsor-search?flowtype=${flowtype}&app=csp`;
    return this._http
      .post(_searchSponsorUrl, sponsorSearchRequest)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description this method will  get sponsor by uuid
   * @date 2019-03-18
   * @returns {Observable<SponsorSearchResponse>}
   * @memberof CommonService
   */
  getSearchSponsorsByUUID(sponsorSearchResponse: SponsorSearchResponse): Observable<SponsorSearchResponse> {
    const _searchSponsorUrl = sponsorSearchResponse.location;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description this method will map addess
   * of sponsor
   * @date 2018-10-16
   * @param {*} sponsor
   * @returns {Address}
   * @memberof SponsorSelectionComponentNew
   */
  mapAddressModel(sponsor: SponsorInformation): Address {
    // creating a address object to be added to sponsor info
    const address = {
      id: null,
      memberId: null,
      addressLine1: sponsor.sponsorAddressLine1,
      addressLine2: null,
      addressLine3: null,
      addressLine4: null,
      city: sponsor.sponsorCity,
      stateId: sponsor.sponsorStateId,
      countryId: sponsor.sponsorCountryId,
      postalCode: sponsor.sponsorPostalCode,
      addressVerificationStatus: false,
      addressType: null,
      state: sponsor.sponsorStateCode,
      stateCode: sponsor.sponsorStateCode,
      countryCode: sponsor.sponsorCountryCode,
      country: sponsor.sponsorCountryCode,
      latitude: null,
      longitude: null,
      defaultAddress: null,
      county: null,
      name: null,
      company: null,
      errorCodes: null,
      formattedAddress: null,
      organization: null,
      countryFullName: null,
      phone: null,
      countryCodeTwo: null,
      residential: false,
      validAddress: false
    };
    return address;
  }

  /** To trim the String values in a object
  * @description
  * @author njagadeesan
  * @date 2019-12-17
  * @param {*} obj
  * @returns {*}
  * @memberof CommonService   */
  trimObjectValues(obj: any): any {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        let value = obj[key];
        if (typeof (value) === 'string') {
          value = value && value.trim();
        }
        obj[key] = value;
      }
    }
    return obj;
  }

  /** To update traget in url
 * @description
 * @author bsubramanian
 * @date 2020-02-10
 * @param {*} obj
 * @returns {*}
 * @memberof CommonService   */
  replaceLinks(ticketingModel: any): any {
    const description = ticketingModel && ticketingModel.description;
    if (description && description.indexOf('<a href') > -1 && description.indexOf('target=_blank') === -1) {
      ticketingModel.description = description.replace(/href=/g, ' target=_blank href=');
    }
  }

  /**
   * To get list of countries
   * @returns Observable
   */
  getAllCountries() {
    const url = ApiUrlConstants.configurationApiUrl + 'countries'
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /**
   * @description to convert code to Id vice-versa
   * @author Akhil
   * @date 2020-03-26
   * @param {*} value
   * @param {boolean} [countryCode]
   * @returns
   * @memberof CommonService
   */
  getCountry(value: any, isCountryCode?: boolean) {
    const countries = this._cacheService.get(CacheKey.COUNTRIES);
    if (countries && value) {
      if (isCountryCode) {
        const country = countries.find((country: any) => country.isocodeThree.toLowerCase() === value.toLowerCase());
        return country && country.id ? country.id : country.countryId;
      } else {
        const country = countries.find((country: any) => country.id ? country.id === value : country.countryId === value);
        return country && country.isocodeThree;
      }
    }
  }


  jumpingScroll(onShow: boolean): void {
    const body = document.body;
    if (body) {
      const offset = (window.innerWidth - body.clientWidth);
      if (onShow) {
        if (offset > 0) {
          $('.global-banner').css({ 'padding-right': offset + 'px' });
          $('.nav-tabs.cs-primary-tabs > ul.nav-tabs, .nav-tabs.cs-secondary-tabs > ul.nav-tabs').css({ 'left': 'calc(50% - 8.5px)' });
        }
      } else {
        $('.global-banner').css({ 'padding-right': '0px' });
        $('.nav-tabs.cs-primary-tabs > ul.nav-tabs, .nav-tabs.cs-secondary-tabs > ul.nav-tabs').css({ 'left': '50%' });
      }
    }
  }
    /**
   * @description to get all the Zip Code Patterns
   * @returns {Observable<any>}
   * @memberof CommonService
   */
  getZipCodePatterns(): Observable<any> {
    return this._http
      .get(environment.uiTemplateBaseUrl + '/test/zipcode-configuration.json')
      .map((res: Response) => res.json())
      .pipe(catchError(this.handleErrorObservable));
  }
  clearKeyCloakCache(userName: string): Observable<any[]> {
    const keyclockCacheUrl = environment.ssoInternalUserCacheUrl
      + userName + '/clear-cache';
    return this._http.get(keyclockCacheUrl).map(response => {
      return response.json();
    }).catch(this.handleErrorObservable);
  }

  isWHLSAL00enabledForAsstSupervisor(countryCode: string): boolean {
    const enabledCountries = environment.enableWHLSAL00ForAsstSupervisor ?
      environment.enableWHLSAL00ForAsstSupervisor.split(',') : null;
    const country = enabledCountries && enabledCountries.length ? enabledCountries.find(ISOcodeThree =>
      ISOcodeThree.toLowerCase() === countryCode.toLowerCase()) : null;
    const enableWHLSAL00ForAsstSupervisor = country && country.length ? true : false;
    return enableWHLSAL00ForAsstSupervisor;
  }
  getCurrencyFormat(store: any, format: string, value: number) {
    const chunkLength = 3;
    value = +value || 0;
    const num = store.numberDecimals ? value.toFixed(Math.max(0, ~~store.numberDecimals)) : value.toFixed(2);
    const result: string = '\\d(?=(\\d{' + chunkLength + '})+' + (store.numberDecimals > 0 ? '\\D' : '$') + ')';
    let formattedCurrency = '';
    //let currencyCode: string = store.currencyCode;
    const currencySymbol: string = store.currencySymbol;
    switch (format) {
      case 'CL':
        formattedCurrency = (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : ''));
        break;
      case 'CR':
        formattedCurrency = (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : ''));
        break;
      case 'SL':
        formattedCurrency = currencySymbol + (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : ''));
        break;
      case 'SR':
        formattedCurrency = (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : '')) + currencySymbol;
        break;
      case 'CRSL':
        formattedCurrency = currencySymbol + (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : ''));
        break;
      case 'SRCL':
        formattedCurrency = (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : '')) + currencySymbol;
        break;
      default:
        formattedCurrency = currencySymbol + (store.decimalSeparator ?
          num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            (store.thousandSeperator ? store.thousandSeperator : ''));
        break;
    }
    return formattedCurrency;
  }
  getMemberShippingDiscountOffer(memberId: number, countryCode: string) {
    const url = ApiUrlConstants.accountApiUrl + 'member-discount-offer/member/' + memberId + '/country/' + countryCode + "?DiscountTypeID=" + DiscountType.ShippingDiscount;
    return this._http.get(url)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
    * get member account level id
    */
  getMemberAccountLevelId(userInfo): number | null {
    let accountLevelId = null;
    if (userInfo && userInfo.memberRankLevels && userInfo.memberRankLevels.length > 0) {
      accountLevelId = userInfo.memberRankLevels[0].accountLevelId ? userInfo.memberRankLevels[0].accountLevelId : null;
    }
    return accountLevelId;
  }
  /**
   * removeMemberDiscountOffer()
   * @param  {number} memberId
   * @returns Observable
   */
  removeMemberDiscountOffer(memberId: number): Observable<any> {
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'member-discount-offer/' + memberId + "?DiscountTypeID=" + DiscountType.ShippingDiscount;
    return this._http
      .delete(url)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * PRICE and CC validation check when order value type is BOTH
   */
  validateSubTotalBasedOnBothPriceAndCC(orderRules: any, isLiteratureProduct: boolean, subTotal: any, totalCC?: any): any {
    let valid: any;
    valid = { thresholdCrossed: false, monthlyCCValue: 0, monthlyCCValid: false, cartLimitExceed: false, cartLimitNotReach: false };
    if (orderRules && isLiteratureProduct) {
      if (subTotal > orderRules.literatureMaxValue) {
        valid.cartLimitExceed = true;
        valid.thresholdCrossed = true;
      } else if (subTotal < orderRules.literatureMinValue) {
        valid.cartLimitNotReach = true;
        valid.thresholdCrossed = true;
      } else {
        valid.thresholdCrossed = false;
      }
    } else if (orderRules && totalCC) {
      if (totalCC >= orderRules.maxCCValue) {
        valid.monthlyCCValid = true;
        valid.thresholdCrossed = true;
      } else {
        valid.monthlyCCValid = false;
        valid.thresholdCrossed = false;
      }
    }
    valid.monthlyCCValue = orderRules.maxCCValue;
    return valid;
  }
  /**
   * @description Get member details are privacy enabled
   * @author njagadeesan
   * @date 2020-09-03
   * @param {*} memberPreferences
   * @returns {string}
   * @memberof CommonService
   */
  isPrivacyRequested(memberPreferences: any): string {
    let byPhoneOrMail;
    if (memberPreferences && memberPreferences.length) {
      byPhoneOrMail = memberPreferences.find((item: any) => {
        return (item.preferenceId === MemberPreferenceType.Email)
          && +item.preferenceValue === PreferenceValues.no;
      });
    }
    return byPhoneOrMail ? 'Yes' : 'No';
  }

  validateNumberDecimalPoint(n: number): boolean {
    return (n - Math.floor(n)) !== 0;
  }
  getMemberInfoByMemberId(memberId: number) {
    if (memberId) {
      const url: string = ApiUrlConstants.accountApiUrl + 'members/lookup?memberIds=' + memberId;
      return this._http
        .get(decodeURIComponent(encodeURIComponent(url)))
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    } else {
      return Observable.throw('Member Id is not available');
    }
  }

  /**
       * getVatDetail()
       * @param selectedCountryID
       */
   getVatDetail(country: any, memberInfo?: any): Boolean {
    if (country && memberInfo && memberInfo.vatDetailModel && memberInfo.vatDetailModel.length
      && memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
      const vatDetail = memberInfo.vatDetailModel.find(item => item.vatRegisteredCountry === Number(country.countryId));
      const appConfigSetting = this.appConfigService.getSettings(country.isocodeThree, memberInfo);
      if (appConfigSetting && appConfigSetting.enableVatExempt) {
        memberInfo.vatRegistered = (vatDetail && vatDetail.vatID && vatDetail.vatExempt) ? true : false;
      } else {
        memberInfo.vatRegistered = vatDetail ? true : false;
      }
      return memberInfo.vatRegistered;
    }
  }


  /**
   * processPollRequest
   * @param  {Order} processPollRequest
   * @returns Observable
   */
  processPollRequest(requestUrl: string): Observable<any> {
    return (
      this._http
        .get(requestUrl)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }
  /**
   * @description To remove payvision widget configurations
   * @author njagadeesan
   * @date 2020-11-19
   * @memberof CommonService
   */
  unloadPayvisionWidget(): void {
    const widgetWindow: any = window;
    if (widgetWindow.wpwl && widgetWindow.wpwl.unload) {
      widgetWindow.wpwl.unload();
      $('script').each(function () {
        const scriptEle: any = this;
        if (scriptEle.src && scriptEle.src.indexOf('static.min.js') !== -1) {
          $(this).remove();
        }
      });
    }
  }

  /**
  *
  * @param storeId
  */
  getStoreMetaData(storeId: number): Observable<any[]> {
    return this._http
      .get(ApiUrlConstants.configurationApiUrl + 'stores/' + storeId + '/store-metadata')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * @description To get Government Identifiction based on country code
   * @date 2021-03-31
   * @returns {Observable<any[]>}
   * @memberof CommonService
   */
 
  getGovermentIdentificationPatterns(): Observable<any[]> {
    //get(environment.uiTemplateBaseUrl + '/test/goverment-identification-patterns.json')
    return this._http
      .get(environment.cdnURL + '/portals/customercare/template1/schema-forms/goverment-identification-patterns.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  anonymousSponsorSearch(distributorId: string):Observable<any[]>{
    const anonymousSponsorSearchRequest = ApiUrlConstants.accountApiUrl + 'fbo/'+distributorId+'/basic-details';
    return this._http
      .get(anonymousSponsorSearchRequest).map((res: Response) => res.json())
      .pipe(catchError(this.handleErrorObservable));
  }

  getPosMembrOrderElible(): Observable<any[]> {
    return this._http
      .get(environment.cdnURL + '/portals/customercare/template1/schema-forms/pos-member-type-config.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  isenableCloneOrderCountries(countryCode: string): boolean {
    const enabledCountries = environment.enableCloneOrderCountries ?
      environment.enableCloneOrderCountries.split(',') : null;
    const country = enabledCountries && enabledCountries.length ? enabledCountries.find(ISOcodeThree =>
      ISOcodeThree.toLowerCase() === countryCode.toLowerCase()) : null;
    const enableCloneOrderCountries = country && country.length ? true : false;
    return enableCloneOrderCountries;
  }

  /**
     * @description Method to sort member address based on name
     * @date 2021-04-21
     * @memberof OrderEditComponent
     */
  sortMemberAddress(memberAddressDetails: any[]) {
    if (memberAddressDetails && memberAddressDetails.length > 1) {
      const direction = 1;
      memberAddressDetails.sort(function (a, b) {
        let nameObj1 = ((a.firstName ? a.firstName : "") +
          (a.middleName ? a.middleName : "") +
          (a.lastName ? a.lastName : "")).toLowerCase();
        let nameObj2 = ((b.firstName ? b.firstName : "") +
          (b.middleName ? b.middleName : "") +
          (b.lastName ? b.lastName : "")).toLowerCase();
        if (nameObj1 < nameObj2) {
          return -1 * direction;
        } else if (nameObj1 > nameObj2) {
          return 1 * direction;
        } else {
          return 0;
        }
      });
    }
    return memberAddressDetails;
  }

  /**
     * @description Method to search address based on name
     * @date 2021-04-21
     * @memberof OrderEditComponent
     */
  searchShippingAddress(event: any, memberAddressDetails: any[]) {
    let addressSearchResult: any[];
    let searchFilter = event.target.value;
    if (searchFilter.length > 0) {
      searchFilter = searchFilter.toLowerCase();
      addressSearchResult = memberAddressDetails.filter(address => {
        let name = ((address.firstName ? address.firstName + " " : "") +
          (address.middleName ? address.middleName + " " : "") +
          (address.lastName ? address.lastName : "")).toLowerCase();
        return name.indexOf(searchFilter) > -1;
      });
    } else {
      addressSearchResult = memberAddressDetails;
    }
    return addressSearchResult;
  }

  focusInvalidElement(): void {
    const invalidFields: any = document.querySelectorAll('.alert-msg');
    if (invalidFields[0]) {
      const offSetHeight = invalidFields[0].offsetTop;
      if (offSetHeight) {
        window.scroll(0, offSetHeight);
      }
    }
  }

  /**
   * Check order Promotion is available
   * @param promotions 
   * @param freeProductsInfo 
   * @param items 
   */
  validateOrderCriteria(promotions, freeProductsInfo, items): void {
    const orderPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.ORDER);
    if(items && items.length > 0) { 
      const orderItems = items.controls.filter(item=>
        item.controls['productItem'].value.orderPromotionTrackings == null);
      if (orderPromotions && orderPromotions.length && orderItems && orderItems.length>0) {
        this.updateSingleProductQuantityPromotion(orderPromotions, freeProductsInfo, items);
      }
    }
  }

  /**
   * Check order sub total is satisfied
   * @param promotions 
   * @param freeProductsInfo 
   * @param items 
   */
  validateOrderSubTotalCriteria(promotions, freeProductsInfo, items): void {
    const orderSubTotalPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.ORDERSUBTOTAL);
    if (orderSubTotalPromotions && orderSubTotalPromotions.length) {
      this.updateSingleProductQuantityPromotion(orderSubTotalPromotions, freeProductsInfo, items, PromotionActionType.ORDERSUBTOTAL);
    }
  }

  /**
   * Check order cc is satisfied
   * @param promotions 
   * @param freeProductsInfo 
   * @param items 
   */
  validateOrderCCCriteria(promotions, freeProductsInfo, items): void {
    const orderOrderCCPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.ORDERCC);
    if (orderOrderCCPromotions && orderOrderCCPromotions.length) {
      this.updateSingleProductQuantityPromotion(orderOrderCCPromotions, freeProductsInfo, items, PromotionActionType.ORDERCC);
    }
  }

  /**
   * Check Qualify product promotion is satisfied
   * @param promotions 
   * @param freeProductsInfo 
   * @param item 
   */
  validateProductCriteria(promotions, freeProductsInfo, items): void {
    const productPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.PRODUCT);
    if (productPromotions && productPromotions.length) {
      productPromotions.forEach(promotion => {
        const productIndex = items.controls.findIndex(item => item.controls['productId'].value ===
          promotion.qualifyingProductId);
        if(productIndex > -1 && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)){
          const productQty = items.controls[productIndex].controls['quantity'].value;  
          freeProductsInfo.push({
              productId: promotion.freeProductId,
              quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount : productQty * promotion.freeProductQuantityCount,
              promotionId: [promotion.promotionId]
            });
          }
      });
    }
  }



  /**
   * Check product at quantity promotion is satisfied
   * @param promotions 
   * @param freeProductsInfo 
   * @param item 
   */
  validateProductAtQuantityCriteria(promotions, freeProductsInfo, items): void {
    const productAtQuantityPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.PRODUCT_QUANTITY);
    if (productAtQuantityPromotions && productAtQuantityPromotions.length) {
      productAtQuantityPromotions.forEach(promotion => {
        const productIndex = items.controls.findIndex(item => item.controls['productId'].value ===
          promotion.qualifyingProductId);
          if(productIndex > -1 && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)){
            const productQty = items.controls[productIndex].controls['quantity'].value;; 
            if(productQty >= promotion.qualifyingQuantityCount){
                freeProductsInfo.push({
                productId: promotion.freeProductId,
                quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount : 
                  Math.floor(productQty / promotion.qualifyingQuantityCount) * promotion.freeProductQuantityCount,
                promotionId: [promotion.promotionId]
              });
            }
          }
      });
    }
  }

  /**
   * Check Mulptiple product promotion is satisfied
   * @param promotions
   * @param freeProductsInfo 
   * @param items 
   */
  validateMultipleProductCriteria(promotions, freeProductsInfo, items): void {
    const multipleProductPromotions = promotions.filter((promotion) => promotion.promotionActionTypeId === PromotionActionType.MULTIPLE_PRODUCTS);
    
    if (multipleProductPromotions && multipleProductPromotions.length && items) {
      multipleProductPromotions.forEach(promotion => {
        const firstProductIndex = items.controls.findIndex(item => item.controls['productId'].value ===
          promotion.qualifyingProductId);
        const secondProductIndex = items.controls.findIndex(item => item.controls['productId'].value ===
          promotion.secondQualifyingProductId);
        if (firstProductIndex > -1 && secondProductIndex > -1) {
          const firstProductQuantity = items.controls[firstProductIndex].controls['quantity'].value;
          const secondProductQuantity = items.controls[secondProductIndex].controls['quantity'].value;
          if (!(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
            freeProductsInfo.push({
              productId: promotion.freeProductId,
              quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount : 
                  Math.min(firstProductQuantity, secondProductQuantity) * promotion.freeProductQuantityCount,
              promotionId: [promotion.promotionId]
            });
          }
        }
      });
    }
  }

  /**
  * To update Free Prodcut Id to Free product info
  * @param promotions
  * @param freeProductsInfo 
  */
  updateSingleProductQuantityPromotion(orderPromotions, freeProductsInfo, items, filter?: number): void {
    orderPromotions.forEach(promotion => {
      if (items && items.length > 0) {
        if ((filter === PromotionActionType.ORDERSUBTOTAL && (this.itemSubTotal < promotion.subTotalValueCap)) ||
          (filter === PromotionActionType.ORDERCC && (this.totalCC < promotion.ccValueCap)) ||
          (promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
          return;
        }
        if(filter === PromotionActionType.ORDERSUBTOTAL && (this.countryTaxInclusive !== promotion.taxOptionValue))  return;
        freeProductsInfo.push({
          productId: promotion.freeProductId,
          quantity: promotion.freeProductQuantityCount,
          promotionId: [promotion.promotionId]
        });
      }
    });
  }

  /**
   * To Remove duplicate product Ids from Free Product Info
   * @param freeProductsInfo
   * @returns 
   */
  removeDuplicates(freeProductsInfo) {
    const products = freeProductsInfo.reduce((item, { productId, quantity , promotionId}) => {
      const index = item.findIndex(i => productId === i.productId);
      if (index === -1) {
        item.push({ productId, quantity, promotion: [{promotionID: promotionId[0], quantity: quantity}] });
      } else {
        item[index].promotion.push({promotionID: promotionId[0], quantity: quantity});
        item[index] = ({ productId, quantity: item[index].quantity + quantity, promotion: item[index].promotion });
      }
      return item;
    },[]);
    return products;
  }

  /**
   * To Set SubTotal, Total CC and CountryTax Inclusive option
   * @param subTotal
   * @param totalCC 
   * @param countryTaxInclusive
   */
  setSubTotalAndOrderCC(subTotal: number, totalCC: number, countryTaxInclusive?: boolean):void {
    this.itemSubTotal = subTotal,
    this.totalCC = totalCC;
    this.countryTaxInclusive = countryTaxInclusive;
  }

  /**
   * To Get Promotions based on store
   * @param storeId
   * @param request 
   * @returns 
   */
  getPromotionEngineConfigurations(storeId: number, request: any) {
    let url = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId + '/promotion-engine/member';
    return this._http.post(url, request)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  depositFeeEnabledProducts(items: any): number {
    let productsCount = 0;
    if (items && items.length) {
      productsCount = items.value.reduce((prev, p) => {
        if (p.depositFeeEnabled) {
          productsCount += 1;
        }
        return productsCount;
      }, 0);
    }
    return productsCount;
  }

  /**
   * To Get stock quantity available
   * @param product
   * @param  currentFreeProduct
   * @returns 
   */
  stockQuantityCheck(product, currentFreeProduct): StockQuantity {
    let stockQuantity: StockQuantity = new StockQuantity();
    let stockBalanceQuantity = product.stockQuantity;
    stockQuantity.currentFreeProductQuantity = 0;
    stockQuantity.orderPromotionTrackings = [];
    currentFreeProduct.promotion.forEach(element => {
      if (product.stockAvailable && !product.manageStock) {
        stockQuantity.orderPromotionTrackings.push(element);
        stockQuantity.currentFreeProductQuantity += element.quantity;
      }
      else if (product.manageStock && stockBalanceQuantity > 0) {
        if (element.quantity >= stockBalanceQuantity) {
          element.quantity = stockBalanceQuantity;
          stockQuantity.orderPromotionTrackings.push(element);
          stockBalanceQuantity = 0;
          stockQuantity.currentFreeProductQuantity += element.quantity;
        }
        else {
          stockBalanceQuantity = stockBalanceQuantity - element.quantity;
          stockQuantity.orderPromotionTrackings.push(element);
          stockQuantity.currentFreeProductQuantity += element.quantity;
        }
      }
    });

    return stockQuantity;
  }

  /**
   * Get Free Products from promotion and update quantity in cart if product exist
   * else add it to FreeProductAdd array
   * @param freeProducts 
   * @param items 
   * @param orderFormGroup
   * @param  promotionIds
   * @returns 
   */
  updateCartAfterPromotion(freeProducts: any, items, orderFormGroup, promotionIds): number[] {
    let freeProductsToAdd = [];
    freeProducts.forEach((freeProductItem) => {
      const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value ===
        freeProductItem.productId);
      if (sameProductIndex >= 0) {
        let product = items.controls[sameProductIndex].controls['productItem'].value;
        let stockQuantity: StockQuantity = this.stockQuantityCheck(product, freeProductItem);
        if (stockQuantity.currentFreeProductQuantity > 0) {
          if (freeProductItem.promotionId && freeProductItem.promotionId.length > 0) {
            freeProductItem.promotionId.forEach((promotionId) => {
              if (promotionIds.indexOf(promotionId) == -1) {
                promotionIds.push(promotionId);
              }
            });
          }
          freeProductItem.quantity = stockQuantity.currentFreeProductQuantity;
          if (+items.controls[sameProductIndex].controls['quantity'].value < 999) {
            items.controls[sameProductIndex].controls['quantity'].setValue(freeProductItem.quantity);
            product.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
            product.quantity = freeProductItem.quantity;
            items.controls[sameProductIndex].controls['productItem'].setValue(product);
            orderFormGroup.controls['itemSearch'].setValue('');
          }
        }
      } else freeProductsToAdd.push(freeProductItem.productId);
    });
    return freeProductsToAdd;
  }

  /**
  * To  remove non promotion products
  * @param freeProductsInfo
  * @param  items
  */
  removeNonPromotionProducts(freeProductsInfo: any[], items: any) {
    if (freeProductsInfo && items) {
      let itemsToRemove = [];
      for (let i = 0; i < items.controls.length; i++) {
        const productId = items.controls[i].controls['productId'].value;
        const productItem = items.controls[i].controls['productItem'].value;
        const index = freeProductsInfo.findIndex(freeProduct => productId === freeProduct.productId);
        if (index < 0 && productItem.orderPromotionTrackings && productItem.orderPromotionTrackings.length > 0) {
          itemsToRemove.push(i);
        }
      }
      if (itemsToRemove.length > 0) {
        itemsToRemove = itemsToRemove.sort((a, b) => b - a);
        itemsToRemove.forEach((index) => {
          items.removeAt(index);
        });
      }
    }
  }

  /**
     * To  add the promotion item 
     * @param  items
     * @param index
     * @param product
     * @param uiTemplateBaseUrl
     * @param cdnURL
     * @returns 
     */
  addPromoItem(items: any, index: number, product: any, uiTemplateBaseUrl: string, cdnURL: string) {
    const itemValue = product.itemNumber + ' - ' + product.name;
    items.controls[index].controls['itemNumber'].setValue(itemValue);
    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
      ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
    const imageUrl = (itemImage && itemImage.url) ? (cdnURL + '/' + itemImage.url)
      : (uiTemplateBaseUrl + '/images/no_image.png');
    items.controls[index].controls['productImage'].setValue(imageUrl);
    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
    items.controls[index].controls['productId'].setValue(product.id);
    product.promoProduct = true;
    items.controls[index].controls['productItem'].setValue(product);
    if(items.controls[index].controls['disableIncrement'])items.controls[index].controls['disableIncrement'].setValue(true);
    if(items.controls[index].controls['disableDecrement'])items.controls[index].controls['disableDecrement'].setValue(true);
    items.controls[index].controls['disableDelete'].setValue(true);
    return items;
  }
  
  /**
   * @date 2021-09-13
   * @returns To get country payment method source configuration
   */
  getPaymentMethodsSourceConfiguration(): any {
    // const url = environment.uiTemplateBaseUrl + '/test/payment-method-source-configuration.json';
    const url = environment.cdnURL + '/portals/customercare/template1/schema-forms/payment-method-source-configuration.json';
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  filterPaymentMethods(paymentMethodSourceConfigurationData: PaymentMethodSourceConfiguration, paymentMethods: any, orderType?:number): any {
    let filteredPaymentMethods = paymentMethods;
    if (paymentMethodSourceConfigurationData && filteredPaymentMethods) {
      let removePaymentMethodIds = [];
      filteredPaymentMethods.forEach((paymentMethod) => {
        if (paymentMethod) {
          let payment = paymentMethodSourceConfigurationData.paymentMethods.find((paymentMethodName) => paymentMethodName.name === paymentMethod.paymentMethodName);
          if(payment && payment.allowedOrderflows){
            const isAllowedPaymentMethod = payment.allowedOrderflows.find(payment => payment === orderType);
            if(!isAllowedPaymentMethod){
              removePaymentMethodIds.push(paymentMethod.paymentMethodId);
            }
          }
          else if(!payment) {
            removePaymentMethodIds.push(paymentMethod.paymentMethodId);
          }
        }
      });
      if (removePaymentMethodIds && removePaymentMethodIds.length > 0) {
        removePaymentMethodIds.forEach((paymentMethodId) => {
          let index = filteredPaymentMethods.findIndex((paymentMethod) => paymentMethod.paymentMethodId == paymentMethodId);
          if (index > -1) {
            filteredPaymentMethods.splice(index, 1);
          }
        });
      }
    }
    return filteredPaymentMethods;
  }

  getLanguageCulture(storeInfo: any, isoThreeCountryCode: string, memberInfo: any) {
    let languageCulture = null;
    let countryLanguage = null
    if (storeInfo && memberInfo && isoThreeCountryCode) {
      const memberHomeCountry = memberInfo.memberAllowedCountries
        .find((country: MemberAllowedCountries) => country.homeCountry === true);
      if (memberHomeCountry && memberHomeCountry.isoCodeThree == isoThreeCountryCode) {
        const preference = memberInfo.memberPreferences.find((preference) => preference.preferenceId == MemberPreferenceType.PreferredCommunicationLanguage);
        if(preference){
        countryLanguage = storeInfo.languages.find((countryLanguage) => countryLanguage.languageCultureId == (+preference.preferenceValue));
        languageCulture = countryLanguage ? countryLanguage.languageCulture : '';
        }
      }
      if (!countryLanguage) {
        languageCulture = storeInfo.languages.find((languageCulture: any) => languageCulture.default).cultureName;
      }
      return languageCulture;
    }
  }

  getMemberLevel(memberLevelID: number): MemberLevel {
    let memberLevel;
    if (memberLevelID === MemberLevel.ASSISTANTSUPERVISOR) {
      memberLevel = UserTitleType.ASSISTANTSUPERVISOR;
    } else if (memberLevelID === MemberLevel.ASSISTANTMANAGER) {
      memberLevel = UserTitleType.ASSISTANTMANAGER;
    } else if (memberLevelID === MemberLevel.DIAMONDCENTURIONMANAGER) {
      memberLevel = UserTitleType.DIAMONDCENTURIONMANAGER;
    } else if (memberLevelID === MemberLevel.DIAMONDMANAGER) {
      memberLevel = UserTitleType.DIAMONDMANAGER;
    } else if (memberLevelID === MemberLevel.DIAMONDSAPPHIREMANAGER) {
      memberLevel = UserTitleType.DIAMONDSAPPHIREMANAGER;
    } else if (memberLevelID === MemberLevel.DOUBLEDIAMONDMANAGER) {
      memberLevel = UserTitleType.DOUBLEDIAMONDMANAGER;
    } else if (memberLevelID === MemberLevel.GUEST) {
      memberLevel = UserTitleType.GUEST;
    } else if (memberLevelID === MemberLevel.MANAGER) {
      memberLevel = UserTitleType.MANAGER;
    } else if (memberLevelID === MemberLevel.NOVICCUSTOMER) {
      memberLevel = UserTitleType.NOVICCUSTOMER;
    } else if (memberLevelID === MemberLevel.PREFERREDCUSTOMER) {
      memberLevel = UserTitleType.PREFERREDCUSTOMER;
    } else if (memberLevelID === MemberLevel.RECOGNIZEDMANAGER) {
      memberLevel = UserTitleType.RECOGNIZEDMANAGER;
    } else if (memberLevelID === MemberLevel.RETAIL) {
      memberLevel = UserTitleType.RETAIL;
    } else if (memberLevelID === MemberLevel.SAPPHIREMANAGER) {
      memberLevel = UserTitleType.SAPPHIREMANAGER;
    } else if (memberLevelID === MemberLevel.SENIORMANAGER) {
      memberLevel = UserTitleType.SENIORMANAGER;
    } else if (memberLevelID === MemberLevel.SOARINGMANAGER) {
      memberLevel = UserTitleType.SOARINGMANAGER;
    } else if (memberLevelID === MemberLevel.SUPERVISOR) {
      memberLevel = UserTitleType.SUPERVISOR;
    } else if (memberLevelID === MemberLevel.TRIPLEDIAMONDMANAGER) {
      memberLevel = UserTitleType.TRIPLEDIAMONDMANAGER;
    } else if (memberLevelID === MemberLevel.UNRECOGNIZEDMANAGER) {
      memberLevel = UserTitleType.UNRECOGNIZEDMANAGER;
    }
    return memberLevel;
  }
  
  getMemberAllowedCountries(memberId:number):Observable<MemberAllowedCountries[]>{
    let url: string = ApiUrlConstants.accountApiUrl+'members/'+ memberId +'/allowed-countries';
    return this._http
    .get(url)
    .map((res:Response) =>res.json())
    .catch(this.handleErrorObservable);
  }

  mapTransliterateProperties(storeDetails:StoreConfig,languageCultureName:string) {
    return {
        enableTransliterate:storeDetails && storeDetails.enableTransliteration ? true: false,
        languageCode: languageCultureName ? languageCultureName : null
    }
}

  hasStoreEnabledTransliteration(storeData) {
    return (storeData && storeData.enableTransliteration) ? true : false;
  }

  getMemberPrefferedLanguage(memberDetails, storeInfo) {
    let languageCode = ''
    const webSitelanguagePreference = memberDetails && !!Object.keys(memberDetails).length && memberDetails.memberPreferences && !!memberDetails.memberPreferences.length && memberDetails.memberPreferences.find(x => x.preferenceId === MemberPreferencesType.PREFERREDWEBSITELANGUAGE);
    let language = webSitelanguagePreference && storeInfo && storeInfo.languages && !!storeInfo.languages.length && storeInfo.languages.find(x => x.languageId === parseInt(webSitelanguagePreference.preferenceValue, 0));
    languageCode = language && language.cultureName;
    if(!languageCode){
      languageCode = this.getStoreDefaultLanguage(storeInfo) ;
    }
    return  languageCode
  }

  getStoreDefaultLanguage(storeInfo){
    let storeDefaultLanguage = ''
    if(storeInfo && storeInfo.languages && !!storeInfo.languages.length){
      let language = storeInfo.languages.find(x => x.default);
      storeDefaultLanguage = language && language.cultureName;
    }
    return storeDefaultLanguage
  }
  getPaymentTypeLabel(pymtType:any){
    switch(pymtType){
        case PaymentMethodTypes.Credit_Card:
            pymtType = PaymentMethodTypeConstants.Credit_Card;
            break;
        case PaymentMethodTypes.eCheck:
            pymtType = PaymentMethodTypeConstants.eCheck;
            break;
        case PaymentMethodTypes.Money_order:
            pymtType = PaymentMethodTypeConstants.Money_Order;
            break;
        case PaymentMethodTypes.Wire_Transfer:
            pymtType = PaymentMethodTypeConstants.Wire_Transfer;
            break;
        case PaymentMethodTypes.Cash:
            pymtType = PaymentMethodTypeConstants.Cash;
            break;
        case PaymentMethodTypes.Ideal:
            pymtType = PaymentMethodTypeConstants.Ideal;
            break;
        case PaymentMethodTypes.PayPal:
            pymtType = PaymentMethodTypeConstants.Paypal;
            break;
        case PaymentMethodTypes.Cash_On_Delivery:
            pymtType = PaymentMethodTypeConstants.Cash_On_Delivery;
            break;
        case PaymentMethodTypes.Bank_Transfer:
            pymtType = PaymentMethodTypeConstants.Bank_Transfer;
            break;
        case PaymentMethodTypes.Integrated_Terminal_Adyen:
            pymtType = PaymentMethodTypeConstants.Integrated_Terminal_Adyen;
            break;
        case PaymentMethodTypes.Pay_By_Link:
            pymtType = PaymentMethodTypeConstants.Pay_By_Link;
            break;   
        case PaymentMethodTypes.Single_Debit:
            pymtType = PaymentMethodTypeConstants.Single_Debit;
            break;
        case PaymentMethodTypes.Direct_Debit:
            pymtType = PaymentMethodTypeConstants.Direct_Debit;
            break;
        case PaymentMethodTypes.Credit_Card_External:
            pymtType = PaymentMethodTypeConstants.Credit_Card_External;
            break;
        case PaymentMethodTypes.Giro_Pay:
            pymtType = PaymentMethodTypeConstants.Giro_Pay;
            break;               
        case PaymentMethodTypes.Blik:
            pymtType = PaymentMethodTypeConstants.Blik;
            break;
        case PaymentMethodTypes.Eps:
            pymtType = PaymentMethodTypeConstants.Eps;
            break;
        case PaymentMethodTypes.MisterCash_and_Maestro:
            pymtType = PaymentMethodTypeConstants.MisterCash_and_Maestro;
            break;
        case PaymentMethodTypes.BanContact_MisterCash_and_Maestro:
            pymtType = PaymentMethodTypeConstants.BanContact_MisterCash_and_Maestro;
            break;
        case PaymentMethodTypes.Orange_Money:
            pymtType = PaymentMethodTypeConstants.Orange_Money;
            break;
        case PaymentMethodTypes.Wave:
            pymtType = PaymentMethodTypeConstants.Wave;
            break;
        case PaymentMethodTypes.Personal_Check:
            pymtType = PaymentMethodTypeConstants.Personal_Check;
            break;
        case PaymentMethodTypes.Ach:
            pymtType = PaymentMethodTypeConstants.Ach;
            break;
        case PaymentMethodTypes.Bonus_Check:
            pymtType = PaymentMethodTypeConstants.Bonus_Check;
            break;
        case PaymentMethodTypes.Travelers_Check:
            pymtType = PaymentMethodTypeConstants.Travelers_Check;
            break;
        case PaymentMethodTypes.Google_Pay:
            pymtType = PaymentMethodTypeConstants.Google_Pay;
            break;
        case PaymentMethodTypes.Apple_Pay:
            pymtType = PaymentMethodTypeConstants.Apple_Pay;
            break;
        case PaymentMethodTypes.Walley:
            pymtType = PaymentMethodTypeConstants.Walley;
            break;
        case PaymentMethodTypes.Twint:
            pymtType = PaymentMethodTypeConstants.Twint;
            break;
        case PaymentMethodTypes.Riverty:
            pymtType = PaymentMethodTypeConstants.Riverty;
            break;
        case PaymentMethodTypes.ApplePay_Adyen:
            pymtType = PaymentMethodTypeConstants.ApplePay_Adyen;
            break;
        case PaymentMethodTypes.GooglePay_Adyen:
            pymtType = PaymentMethodTypeConstants.GooglePay_Adyen;
            break;
        default:
            pymtType = PaymentMethodTypeConstants.Credit_Card;
            break;
    }
    return pymtType;
    
}

  applyPromotionFreeShipping(shippingMethods: ShippingMethod[], promotionModels: any[], items: any[], totalCC: number) {
    if (promotionModels && promotionModels.length) {
      for (let promotion of promotionModels) {
        if (promotion.promotionRewardTypeId && promotion.promotionRewardTypeId === PromotionRewardTypeEnum.Free_Shipping 
          && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
          const promotionShippingMethodIds = promotion.shippingMethods && promotion.shippingMethods.split(",");
          if (promotionShippingMethodIds && promotionShippingMethodIds.length) {
            // Free shipping eligible check
            let freeShippingEligible = this.promotionEligiblityCheck(promotion, totalCC, items);
            if (freeShippingEligible) {
              this.applyFreeShipping(shippingMethods, promotionShippingMethodIds, promotion);
            }
          }
        }
      }
    }
  }

  applyFreeShipping(shippingMethods: ShippingMethod[], promotionShippingMethodIds: string[], promotion: any) {
    if (shippingMethods && shippingMethods.length && promotionShippingMethodIds) {
      shippingMethods.forEach((shippingMethod) => {
        if (promotionShippingMethodIds.includes(shippingMethod.shippingMethodId + "") && !shippingMethod.freeShippingEligible) {
          shippingMethod.originalShippingCost = shippingMethod.shippingCharge ? shippingMethod.shippingCharge : 0;
          shippingMethod.freeShippingEligible = true;
          shippingMethod.shippingCharge = 0;
          shippingMethod.shippingTax = 0;
          shippingMethod.promotionId = promotion && promotion.promotionId ? promotion.promotionId : null;
        }
      });
    }
  }

  promotionEligiblityCheck(promotion, totalCC, items): boolean {
    let eligible = false;
    if (promotion.promotionActionTypeId == PromotionActionType.ORDER) {
      eligible = true;
    } else if (promotion.promotionActionTypeId == PromotionActionType.ORDERCC) {
      if (totalCC && promotion.ccValueCap && totalCC >= promotion.ccValueCap) {
        eligible = true;
      }
    } else if (promotion.promotionActionTypeId == PromotionActionType.PRODUCT && items && items.length) {
      const productIndex = items.controls.findIndex(item => item.controls['productId'].value === promotion.qualifyingProductId);
      if (productIndex >= 0) {
        eligible = true;
      }
    }
    return eligible;
  }
  
  singleOrDirectDebitCardEligibilityCheck(response: any[], countryCode: string, homeCountryCode: string): any[] {
    if(response != null && countryCode != null && homeCountryCode != null){
        const hasSingleOrDirectDebit = response.some(x =>
          x.paymentMethodName === PaymentMethodTypes.Single_Debit ||
          x.paymentMethodName === PaymentMethodTypes.Direct_Debit
        );
        if (hasSingleOrDirectDebit && countryCode.toLowerCase() !== homeCountryCode.toLowerCase()) {
          return response.filter(x =>
            !(x.paymentMethodName === PaymentMethodTypes.Single_Debit ||
              x.paymentMethodName === PaymentMethodTypes.Direct_Debit)
          );
        }
    }
    return response;
  }
  

}



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts